// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1cKif","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__CAcTx"};